import * as React from 'react';

import GlobalLoadingContext from 'common/components/GlobalLoader/context';

import FullScreenLoader from '../FullScreenLoader';

export default class FullScreenGlobalLoadingWrapper extends React.PureComponent {
  render() {
    return (
      <GlobalLoadingContext.Consumer>
        {globalLoadingProps => <FullScreenLoader visible={globalLoadingProps.globalLoading} />}
      </GlobalLoadingContext.Consumer>
    );
  }
}
